var render = function render(){var _vm=this,_c=_vm._self._c;return _c('color-picker',{staticClass:"d-flex justify-content-center",attrs:{"wheel-lightness":false,"handle-radius":20},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})
}
var staticRenderFns = []

export { render, staticRenderFns }